import { lazy } from "react";

export const publicRoutes = [
  // {
  //   path: "/",
  //   Component: lazy(() => import("../views/auth/login")),
  //   exact: true,
  // },
  {
    path: "/policy/assign/:policyId",
    Component: lazy(() => import("../views/AssignToPolicy")),
    exact: true,
  },
  {
    path: "/survey/:surveyId",
    Component: lazy(() => import("../views/survey")),
    exact: true,
  },
  {
    path: "/surveys/:surveyId",
    Component: lazy(() => import("../views/survey")),
    exact: true,
  },
];

export const privateRoutes = [];
